<template>
  <b-card>
    <b-tabs>
      <b-tab active title="Ticket Info">
        <div v-if="loading" class="d-flex justify-content-center mb-1">
          <b-spinner
            variant="success"
            label="Spinning"
            block
            style="width: 3rem; height: 3rem"
          ></b-spinner>
        </div>
        <b-form @submit.prevent v-if="!loading">
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Ticket Number"
                label-for="ticket_number"
                label-cols-md="4"
              >
                <b-form-input
                  id="ticket_number"
                  v-model="ticketId.reference"
                  type="text"
                  placeholder="Ticket Number"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Customer"
                label-for="h-Customer-Id"
                label-cols-md="4"
              >
                <b-form-input
                  id="customer"
                  v-model="customerName"
                  type="text"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Title" label-for="title" label-cols-md="4">
                <b-form-input
                  id="title"
                  v-model="ticketId.name"
                  type="text"
                  placeholder="Title"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Category"
                label-for="category"
                label-cols-md="4"
              >
                <b-form-select
                  v-model="ticketId.category"
                  :options="optionsCategory"
                  disabled
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Products / Services"
                label-for="Product"
                label-cols-md="4"
              >
                <b-form-input
                  id="product"
                  v-model="productName"
                  type="text"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Description"
                label-for="h-Description"
                label-cols-md="4"
              >
                <b-form-textarea
                  id="description"
                  v-model="ticketId.description"
                  class="mb-2 mb-lg-0"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Assigned To"
                label-for="assigned"
                label-cols-md="4"
              >
                <b-form-input
                  id="assigned"
                  v-model="assignedToName"
                  type="text"
                  readonly
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Status" label-for="status" label-cols-md="4">
                <b-form-select
                  v-model="ticketId.status"
                  :options="statusOptions"
                  :disabled="isStatusClosed"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Priority"
                label-for="priority"
                label-cols-md="4"
              >
                <b-form-select
                  v-model="ticketId.priority"
                  :options="options"
                  :disabled="isStatusClosed"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Due Date"
                label-for="due_date"
                label-cols-md="4"
              >
                <b-form-datepicker
                  id="due_date"
                  v-model="ticketId.dueDate"
                  :disabled="isStatusClosed"
                />
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col offset-md="4">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                @click="submitTicket()"
                type="submit"
                variant="primary"
                class="mr-1"
              >
                Submit
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-tab>
      <b-tab title="Comment History">
        <b-row>
          <b-col cols="12">
            <div class="d-flex justify-content-end">
              <b-modal
                id="modal-add-comment"
                ok-only
                ok-title="Add"
                centered
                size="lg"
                title="Add Comment"
                :hide-footer="true"
                ref="addcommentModal"
              >
                <AddComment :ticketId="id" @add-comment="addComment" />
              </b-modal>
              <b-button variant="primary" v-b-modal.modal-add-comment>
                <feather-icon icon="PlusIcon" class="mr-50" />
                Add Comment
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-between">
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="w-50"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" class="my-1">
            <b-form-group
              label="Filter"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="d-flex justify-content-center mb-1">
            <b-spinner
              variant="success"
              label="Spinning"
              block
              v-if="loading"
              style="width: 3rem; height: 3rem"
            ></b-spinner>

            <b-table
              v-else
              striped
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="items"
              :fields="fields"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:cell(comment)="data">
                {{ data.item.comment }}
              </template>
              <template v-slot:cell(addedOn)="data">
                {{ formatDate(data.item.createdOn) }}
              </template>
              <template v-slot:cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item @click="removeComment(data.item.id)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-col>

          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BCardText,
  BCardTitle,
  BMedia,
  BAvatar,
  BSpinner,
  BMediaAside,
  BMediaBody,
  BImg,
  BCardBody,
  BBadge,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BButton,
  BDropdown,
  BLink,
  BDropdownItem,
  BAlert,
  BCollapse,
  BFormSelect,
  BTabs,
  BTab,
  BTable,
  BFormCheckbox,
  BFormTextarea,
  BFormDatepicker,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import AddComment from "./AddComment.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardTitle,
    BMedia,
    BAvatar,
    BSpinner,
    BMediaAside,
    BMediaBody,
    BImg,
    BCardBody,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BPagination,
    BButton,
    BDropdown,
    BLink,
    BDropdownItem,
    BAlert,
    BCollapse,
    BFormSelect,
    BTabs,
    BTab,
    BTable,
    BFormCheckbox,
    BFormTextarea,
    AddComment,
    BFormDatepicker,
  },

  data() {
    return {
      id: this.$route.params.id,
      optionsCategory: [
        { value: "Billing", text: "Billing" },
        { value: "GeneralInquiry", text: "General" },
      ],
      statusOptions: [
        { value: "Open", text: "Open" },
        { value: "Closed", text: "Closed" },
      ],
      options: [
        { value: "Low", text: "Low" },
        { value: "Medium", text: "Medium" },
        { value: "High", text: "High" },
      ],
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      fields: [
        { key: "comment", label: "Comment", sortable: true },
        { key: "addedOn", label: "Added On", sortable: true },
        "Actions",
      ],
      items: [],
      loading: false,
      isStatusClosed: false,
    };
  },
  computed: {
    ...mapGetters("ticketModule", {
      ticketId: "ticketId",
      ticketLoading: "loading",
    }),
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      custId: "custId",
      customerLoading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      salesPersonLoading: "loading",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      productID: "productID",
      productLoading: "loading",
    }),
    loading() {
      // Return true if any of the loading states are true
      return (
        this.ticketLoading ||
        this.customerLoading ||
        this.salesPersonLoading ||
        this.productLoading
      );
    },
    customerName() {
      if (this.ticketId && this.ticketId.customerId) {
        return this.getCustomer(this.ticketId.customerId);
      }
      return "";
    },
    assignedToName() {
      if (this.ticketId && this.ticketId.assignedTo) {
        return this.getSalePersonName(this.ticketId.assignedTo);
      }
      return "";
    },
    productName() {
      if (this.ticketId && this.ticketId.items.length > 0) {
        const productId = this.ticketId.items[0].itemId;
        const product = this.ProductList.find(
          (product) => product.id === productId
        );
        return product ? product.name : "";
      }
      return "";
    },
  },
  methods: {
    ...mapActions("ticketModule", [
      "getTicketIdAction",
      "addCommentAction",
      "removeCommentAction",
      "updateTicketAction",
    ]),
    ...mapActions("customerModule", ["getCustomersListAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("productModule", [
      "getProductListAction",
      "getProductIDAction",
    ]),
    getCustomer(id) {
      const customer = this.CustomerList.find((s) => s.id === id);
      return customer ? customer.otherName : "-";
    },
    getSalePersonName(id) {
      const salesPerson = this.SalesPersonList.find((s) => s.id === id);
      return salesPerson
        ? salesPerson.firstName + " " + salesPerson.lastName
        : "-";
    },
    getProductName(id) {
      const productName = this.ProductList.find((s) => s.id === id);
      return productName ? productName.name : "-";
    },
    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    successAdd() {
      this.$swal({
        title: "Comment Added!",
        text: "You have successfully added a comment!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    successDelete() {
      this.$swal({
        title: "Comment Deleted!",
        text: "You have successfully deleted a comment!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorAdd(error) {
      this.$swal({
        title: "Error!",
        text: error.response.data.message || " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    errorDelete() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    async fetchDataAndRefreshTable() {
      try {
        // Set loading state to true
        this.loading = true;

        // Fetch data
        await this.getTicketIdAction(this.id);
        await this.getCustomersListAction();
        await this.getSalesPersonListAction();
        await this.getProductListAction(true);

        // Sort and update table data
        this.items = this.ticketId.comments;
        this.items.sort(
          (a, b) => new Date(a.createdOn) - new Date(b.createdOn)
        );
        this.totalRows = this.items.length;

        // Set loading state to false
        this.loading = false;
      } catch (error) {
        // Handle error
        // Set loading state to false even in case of error
        this.loading = false;
      }
    },
    async addComment(comment) {
      try {
        // Call the addCommentAction with the payload
        const payload = {
          comment,
          ticketId: this.id,
        };
        await this.addCommentAction(payload);
        // Display a success message or perform any other necessary action
        this.successAdd();
        // close modal after successful add
        this.$bvModal.hide("modal-add-comment");
        // Refresh table
        await this.fetchDataAndRefreshTable();
      } catch (error) {
        this.errorAdd(error);
        // close modal after successful add
        this.$bvModal.hide("modal-add-comment");
      }
    },
    async removeComment(commentId) {
      try {
        // Call the removeCommentAction with the commentId
        await this.removeCommentAction(commentId);
        // Display a success message or perform any other necessary action
        this.successDelete();
        // Refresh table
        await this.fetchDataAndRefreshTable();
      } catch (error) {
        this.errorDelete();
      }
    },
    async submitTicket() {
      try {
        // Prepare the payload with updated values
        const payload = {
          id: this.id,
          status: this.ticketId.status,
          priority: this.ticketId.priority,
          dueDate: this.ticketId.dueDate,
        };

        // Call the updateTicketAction with the payload
        await this.updateTicketAction({ id: this.id, payload: payload });

        // Display a success message or perform any other necessary action
        this.$swal({
          title: "Success!",
          text: "Ticket updated successfully!",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        await this.fetchDataAndRefreshTable();

        // Update isStatusClosed based on the updated ticket status
        this.isStatusClosed = this.ticketId.status === "Closed";
      } catch (error) {
        // Handle error
        this.$swal({
          title: "Error!",
          text: "Failed to update ticket!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },
  },
  mounted() {
    this.fetchDataAndRefreshTable().then(() => {
      console.log("ticketId status", this.ticketId.status);
      this.isStatusClosed = this.ticketId.status === "Closed";
      console.log("isStatusClosed", this.isStatusClosed);
    });
  },
};
</script>
